import React from 'react';
import './PaymentRequest.css'

const PaymentRequest = ({avatar, name, productName, email, price, requestData, setisRequestExpand}) => {
    return(
        <div className="payment-request" onClick={() => setisRequestExpand({id: requestData.id, expand: true, supplierId: requestData.supplierId, amount: requestData.amount, businessId: requestData.businessId, purchaseId: requestData.purchaseId, paymentId: requestData.paymentId, buyerId: requestData.buyerId})}>
            <div className="avatar">
                <img src={avatar ? avatar : "./img/avatar.png"} alt="profile" />
            </div>
            <div className="content">
                <h2>{name && name}</h2>
                <p>{productName && productName}</p>
                <p>{email && email}</p>
            </div>
            <div className="price">
                <h3>${price && price}</h3>
            </div>
        </div>
    )
};

export default PaymentRequest;

